export default function sortNumbers(first: number, second: number): number {
  return first - second;
}
